import "./Level14.scss";

export default function Level14() {
  return (
    <div className="level14__container">
      <div className="level14__puzzle">
        <div className="level14__div-columns-headers">
          <span className="level14__column-header">\</span>
          <span className="level14__column-header">A</span>
          <span className="level14__column-header">D</span>
          <span className="level14__column-header">F</span>
          <span className="level14__column-header">G</span>
          <span className="level14__column-header">V</span>
          <span className="level14__column-header">X</span>
        </div>
        <div className="level14__div-rows">
          <div className="level14__row">
            <span className="level14__row-header">A</span>
            <span className="level14__row-text">0</span>
            <span className="level14__row-text">F</span>
            <span className="level14__row-text">Q</span>
            <span className="level14__row-text">B</span>
            <span className="level14__row-text">I</span>
            <span className="level14__row-text">Z</span>
          </div>

          <div className="level14__row">
            <span className="level14__row-header">D</span>
            <span className="level14__row-text">W</span>
            <span className="level14__row-text">1</span>
            <span className="level14__row-text">X</span>
            <span className="level14__row-text">M</span>
            <span className="level14__row-text">8</span>
            <span className="level14__row-text">E</span>
          </div>

          <div className="level14__row">
            <span className="level14__row-header">F</span>
            <span className="level14__row-text">R</span>
            <span className="level14__row-text">N</span>
            <span className="level14__row-text">2</span>
            <span className="level14__row-text">G</span>
            <span className="level14__row-text">T</span>
            <span className="level14__row-text">S</span>
          </div>

          <div className="level14__row">
            <span className="level14__row-header">G</span>
            <span className="level14__row-text">K</span>
            <span className="level14__row-text">P</span>
            <span className="level14__row-text">U</span>
            <span className="level14__row-text">3</span>
            <span className="level14__row-text">J</span>
            <span className="level14__row-text">D</span>
          </div>

          <div className="level14__row">
            <span className="level14__row-header">V</span>
            <span className="level14__row-text">O</span>
            <span className="level14__row-text">7</span>
            <span className="level14__row-text">H</span>
            <span className="level14__row-text">Y</span>
            <span className="level14__row-text">4</span>
            <span className="level14__row-text">V</span>
          </div>

          <div className="level14__row">
            <span className="level14__row-header">X</span>
            <span className="level14__row-text">9</span>
            <span className="level14__row-text">C</span>
            <span className="level14__row-text">L</span>
            <span className="level14__row-text">6</span>
            <span className="level14__row-text">A</span>
            <span className="level14__row-text">5</span>
          </div>
        </div>
      </div>

      <div className="level14__guess-container">
        <span className="level14__guess">ADFAAVFVAX &nbsp; FDDXAGDXXF</span>
      </div>
    </div>
  );
}
